<div class="iats-container">

  <!-- Header -->
  <div class="iats-header">
    <h2 class="iats-title">Add to Test Suite</h2>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="onCancel()"
      aria-label="Close">
      <img
        [src]="isActive ? 'assets/images/virtusa-icons/close-dark.svg' : 'assets/images/virtusa-icons/close.svg'"
        alt="Close"/>
    </button>
  </div>

  <!-- Body -->
  <div class="iats-body" #modalBody>

    <!-- Card: Add to New Test Suite -->
    <div class="iats-card" [class.iats-card--active]="isNewSuite">
      <div class="iats-card-header">
        <div class="iats-card-info">
          <p class="iats-card-title">Add to New Test Suite</p>
          <p class="iats-card-desc">Create a new test suite to organize the selected test cases.</p>
        </div>
        <button
          type="button"
          role="switch"
          [attr.aria-checked]="isNewSuite"
          class="iats-toggle"
          [class.iats-toggle--on]="isNewSuite"
          (click)="onToggleNew()"
          aria-label="Toggle add to new test suite">
        </button>
      </div>

      <ng-container *ngIf="isNewSuite">
        <div class="iats-field">
          <label for="iats-suite-name" class="iats-field-label">
            Test Suite name<span class="iats-required">*</span>
          </label>
          <input
            id="iats-suite-name"
            type="text"
            class="iats-input"
            placeholder="Add test suite name"
            [(ngModel)]="newSuiteName"
            [disabled]="isSaving"
            autocomplete="off"/>
          <p class="iats-field-hint">Use a clear, descriptive name to help identify the test suite.</p>
        </div>
      </ng-container>
    </div>

    <!-- Card: Add to Existing Test Suite -->
    <div class="iats-card" [class.iats-card--active]="isExistingSuite">
      <div class="iats-card-header">
        <div class="iats-card-info">
          <p class="iats-card-title">Add to Existing Test Suite</p>
          <p class="iats-card-desc">
            Select an existing test suite to maintain consistency, prevent duplicates, and keep
            related test cases organized for efficient test management.
          </p>
        </div>
        <button
          type="button"
          role="switch"
          [attr.aria-checked]="isExistingSuite"
          class="iats-toggle"
          [class.iats-toggle--on]="isExistingSuite"
          (click)="onToggleExisting()"
          aria-label="Toggle add to existing test suite">
        </button>
      </div>

      <ng-container *ngIf="isExistingSuite">
        <div class="iats-field">
          <label for="iats-suite-select" class="iats-field-label">
            Test Suite name<span class="iats-required">*</span>
          </label>
          <div class="iats-select-wrapper">
            <select
              id="iats-suite-select"
              class="iats-select"
              [(ngModel)]="selectedSuiteId"
              [disabled]="isSaving || isLoadingSuites">
              <option value="" disabled hidden>
                {{ isLoadingSuites ? 'Loading…' : 'Select test suite name' }}
              </option>
              <option *ngFor="let suite of existingSuites" [value]="suite.id ?? suite._id">
                {{ suite.testSuiteName ?? suite.versionName }}
              </option>
            </select>
            <span class="iats-select-arrow" *ngIf="!isLoadingSuites">&#8964;</span>
            <span *ngIf="isLoadingSuites" class="iats-spinner" aria-label="Loading suites"></span>
          </div>
          <p class="iats-field-hint">Choose the test suite where you want to add the selected test cases.</p>
        </div>
      </ng-container>
    </div>

    <div #errorPanel class="iats-error-anchor">
      <app-import-validation-error-panel
        [groups]="validationErrors"
        [summary]="validationSummary"
        [duplicateNote]="duplicateNote">
      </app-import-validation-error-panel>
      <p class="iats-error" *ngIf="saveError">{{ saveError }}</p>
    </div>

  </div>

  <!-- Footer -->
  <div class="iats-footer">
    <div class="iats-footer-actions">
      <button type="button" class="btn-accello-secondary mx-2" [disabled]="isSaving" (click)="onCancel()">
        Cancel
      </button>
      <button type="button" class="btn-accello-primary-light d-inline-flex align-items-center gap-2"
        [disabled]="!canAdd"
        (click)="onAdd()">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ isSaving ? 'Adding...' : 'Add' }}
      </button>
    </div>
  </div>

</div>
